import type { QueryClient } from '@tanstack/react-query';
import { redirect } from '@tanstack/react-router';
import { type CurrentUser, fetchCurrentUser } from '@wundo/client/auth.ts';

/**
 * A refusal and an outage answer the same here: neither is a reason to send
 * somebody to the farewell page, and the practice screen is open to link
 * visitors who have no account to read at all.
 */
export async function currentUserOrNull(
  queryClient: QueryClient,
): Promise<CurrentUser | null> {
  try {
    return await queryClient.ensureQueryData({
      queryKey: ['currentUser'],
      queryFn: fetchCurrentUser,
    });
  } catch {
    return null;
  }
}

/**
 * The one place the app turns "your pilot has ended" into a destination, so a
 * member whose access ran out lands on the same page whichever address they
 * opened, and no page has to carry an empty-handed version of itself.
 */
export async function redirectIfPilotEnded(queryClient: QueryClient): Promise<void> {
  const user = await currentUserOrNull(queryClient);

  if (user?.status === 'expired') {
    throw redirect({ to: '/pilot-ended', replace: true });
  }
}
